import React, { useState } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { invokeApig } from '../../libs/awsLib';
import { cloneDeep } from 'lodash';
import { XSOLIS_USER_TYPE, REVIEW_TYPES } from '../../libs/Constants';
import { isValidUUID } from '../../libs/isValidUUIDUtility';
import REVIEW_TYPES_RR from '../../libs/ReviewTypes';

const ReviewType = (props) => {
  const isXsolisUser = props.userTypeId === XSOLIS_USER_TYPE;
  const { data } = props;
  const isDragonflyEncounter =
    isValidUUID(data.admission_id) && isValidUUID(data.entity_id);

  const PLATFORM_REVIEW_TYPES = isDragonflyEncounter
    ? REVIEW_TYPES_RR
    : REVIEW_TYPES;

  // Initialize options for dropdown menu, with ID being the ESCALATING_REVIEW_TYPE_ID stored in the PATIENT_QUEUE table
  const p2pTypeId = isXsolisUser
    ? PLATFORM_REVIEW_TYPES.ESCALATE_FOR_XSOLIS_PEER_TO_PEER
    : PLATFORM_REVIEW_TYPES.ESCALATE_FOR_PEER_TO_PEER;
  const reviewTypeDropdownOptions = [
    {
      key: 0,
      id: PLATFORM_REVIEW_TYPES.MANUAL,
      text: 'Manual',
      value: 'Manual',
    },
    {
      key: 1,
      id: PLATFORM_REVIEW_TYPES.INITIAL,
      text: 'Status Determination',
      value: 'Status Determination',
    },
    {
      key: 2,
      id: PLATFORM_REVIEW_TYPES.APPEAL_RETROSPECTIVE,
      text: 'Appeal/ Retrospective',
      value: 'Appeal/Retrospective',
    },
    { key: 3, id: p2pTypeId, text: 'Peer-to-Peer', value: 'Peer-to-Peer' },
  ];

  // Initialize review type value shown in dropdown to review type requested in props, changing to match desired UI text
  const [typeValue, setTypeDescValue] = useState(
    data.escalating_review_type_desc === 'Appeal/Retrospective'
      ? reviewTypeDropdownOptions[2].value
      : data.review_type_requested === 'Physician Advisor'
      ? reviewTypeDropdownOptions[1].value
      : data.review_type_requested
  );

  // Call function to save updates to DB on dropdown value change
  const saveTypeChange = async (value) => {
    const dropdownValues = reviewTypeDropdownOptions.map(
      (option) => option.value
    );
    if (!value || !dropdownValues.includes(value)) {
      return;
    }

    // Do not save change if user chooses current review type from dropdown
    if (
      (props.data.escalating_review_type_desc === 'Appeal/Retrospective' &&
        value === reviewTypeDropdownOptions[2].value) ||
      (props.data.review_type_requested === 'Physician Advisor' &&
        value === reviewTypeDropdownOptions[1].value) ||
      props.data.review_type_requested === value
    ) {
      return;
    }

    // Get ID from dropdown options object to send with text value to store in DB
    const reviewTypeRequestedId = Object.values(reviewTypeDropdownOptions).find(
      (option) => option.value === value
    ).id;

    try {
      await invokeApig({
        service: 'PATIENT_QUEUE',
        path: '/patient-queue/update-manual-review-type',
        method: 'PUT',
        body: {
          patient_queue_id: props.data.patient_queue_id,
          entity_id: props.data.entity_id,
          patient_id: props.data.patient_id,
          admission_id: props.data.admission_id,
          review_type_requested_id: reviewTypeRequestedId,
          // Change value text to final text stored in ESCALATING_REVIEW_TYPE_DESC column in PATIENT_QUEUE table
          review_type_requested_desc:
            value === reviewTypeDropdownOptions[1].value
              ? 'Initial'
              : value === reviewTypeDropdownOptions[3].value && isXsolisUser
              ? 'Escalate for XSOLIS Peer-to-Peer'
              : value === reviewTypeDropdownOptions[3].value && !isXsolisUser
              ? 'Escalate for Peer-to-Peer'
              : value,
        },
      });

      // Build new queue array to replace state from props to re-render number count/filters in header
      const currentState = cloneDeep(props.state);
      const currentRowIndex = currentState.queue
        .map((item) => item.patient_queue_id)
        .indexOf(props.data.patient_queue_id);
      const otherRowsState = currentState.queue.filter((item) => {
        return item.patient_queue_id !== props.data.patient_queue_id;
      });

      const currentRowState = { ...props.data };
      currentRowState.escalating_review_type_id = reviewTypeRequestedId;
      currentRowState.escalating_review_type_desc =
        value === reviewTypeDropdownOptions[0].value
          ? null
          : value === reviewTypeDropdownOptions[1].value
          ? 'Initial'
          : value === reviewTypeDropdownOptions[3].value && isXsolisUser
          ? 'Escalate for XSOLIS Peer-to-Peer'
          : value === reviewTypeDropdownOptions[3].value && !isXsolisUser
          ? 'Escalate for Peer-to-Peer'
          : value;
      currentRowState.review_type_requested =
        value === reviewTypeDropdownOptions[1].value
          ? 'Physician Advisor'
          : value;
      otherRowsState.splice(currentRowIndex, 0, currentRowState);

      currentState.queue = otherRowsState;
      props.setState(currentState);
    } catch (error) {
      console.log(error);
    }
    return null;
  };

  const handleTypeChange = (event, data) => {
    if (data.value === '') {
      return;
    }

    setTypeDescValue(data.value);
    saveTypeChange(data.value);
  };

  return (
    <React.Fragment>
      <Dropdown
        id='review_type_requested'
        placeholder='Manual'
        selection
        fluid
        options={reviewTypeDropdownOptions}
        value={typeValue}
        onChange={handleTypeChange}
      />
    </React.Fragment>
  );
};

export default ReviewType;
